import { ALLOWED_ROLES, REMOTE_CONFIG_KEYS, withRemoteConfigKey } from '@src/packages/utils';

import { PATHS } from './constants';
import ShiftBiweekly from './screens/ShiftBiweekly';
import ShiftCycle from './screens/ShiftCycle';
import ShiftFixed from './screens/ShiftFixed';
import ShiftOptions from './screens/ShiftOptions';
import ShiftPartTime from './screens/ShiftPartTime';
import Shifts from './screens/Shifts';
import { ShiftProvider } from './screens/Shifts/context';
import ShiftWorkday from './screens/ShiftWorkday';

const routes = [
  {
    component: () => (
      <ShiftProvider>
        <Shifts />
      </ShiftProvider>
    ),
    path: PATHS.BASE_URL,
    exact: true,
    allowedRoles: ALLOWED_ROLES.ORGANIZATIONS.WORK_SHIFTS.LIST,
    onOrgChangeRedirectTo: `/:orgId/-/${PATHS.BASE_URL}`,
  },
  {
    component: ShiftOptions,
    path: PATHS.SHIFT_OPTIONS,
    writeOnly: true,
    allowedRoles: ALLOWED_ROLES.ORGANIZATIONS.WORK_SHIFTS.CREATE,
    onOrgChangeRedirectTo: `/:orgId/-/${PATHS.BASE_URL}`,
  },
  {
    component: ShiftFixed,
    path: PATHS.SHIFT_FIXED + '/:shiftId?',
    allowedRoles: ALLOWED_ROLES.ORGANIZATIONS.WORK_SHIFTS.CREATE,
    onOrgChangeRedirectTo: `/:orgId/-/${PATHS.BASE_URL}`,
  },
  {
    component: ShiftCycle,
    path: PATHS.SHIFT_CYCLE + '/:shiftId?',
    allowedRoles: ALLOWED_ROLES.ORGANIZATIONS.WORK_SHIFTS.CREATE,
    onOrgChangeRedirectTo: `/:orgId/-/${PATHS.BASE_URL}`,
  },
  {
    component: ShiftBiweekly,
    path: PATHS.SHIFT_BIWEEKLY + '/:shiftId?',
    allowedRoles: ALLOWED_ROLES.ORGANIZATIONS.WORK_SHIFTS.CREATE,
    onOrgChangeRedirectTo: `/:orgId/-/${PATHS.BASE_URL}`,
  },
  {
    component: ShiftWorkday,
    path: PATHS.SHIFT_WORKDAY + '/:shiftId?',
    allowedRoles: ALLOWED_ROLES.ORGANIZATIONS.WORK_SHIFTS.CREATE,
    onOrgChangeRedirectTo: `/:orgId/-/${PATHS.BASE_URL}`,
  },
  {
    component: ShiftPartTime,
    path: PATHS.SHIFT_PART_TIME + '/:shiftId?',
    allowedRoles: ALLOWED_ROLES.ORGANIZATIONS.WORK_SHIFTS.CREATE,
    onOrgChangeRedirectTo: `/:orgId/-/${PATHS.BASE_URL}`,
  },
];

export default withRemoteConfigKey(REMOTE_CONFIG_KEYS.TIME_TRACKER, routes);
